export const ActionTypes = {
    GET_TASKS_LIST: "GET_TASKS_LIST",
    SET_TASKS_FILTER: "SET_TASKS_FILTER",
    SET_MY_TASKS_FILTER: "SET_MY_TASKS_FILTER",
    RESET_STATE: 'RESET_STATE'
};
